import { Outlet } from 'react-router-dom';
import { site } from '../../content/site';
import { currentVariant } from '../../lib/variant';
import { Header } from './Header';
import { Footer } from './Footer';
import { ScrollToTop } from './ScrollToTop';

/**
 * The frame every route renders inside: skip link, header, main landmark,
 * footer.
 *
 * `main` is the skip-link target and is focusable programmatically so keyboard
 * users land inside the content rather than at the top of the document again
 * (spec section 18).
 */
export function RootLayout() {
  return (
    <div className="flex min-h-screen flex-col bg-field" data-variant={currentVariant()}>
      <ScrollToTop />
      <a
        href="#main"
        className="sr-only rounded-md focus:not-sr-only focus:absolute focus:left-4 focus:top-4 focus:z-50 focus:bg-ink focus:px-4 focus:py-3 focus:font-semibold focus:text-field"
      >
        {site.skipToContentLabel}
      </a>
      <Header />
      <main id="main" tabIndex={-1} className="flex-1 focus:outline-none">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
